import {ReportAPI} from "@/apis/ReportAPI";

export default {
    data () {
        return {
              pdfDownloading: false,
        }
    },
    methods: {
        downloadReport(id) {
            this.pdfDownloading = true;
            ReportAPI.getPreSignedUrl(id).then( (url) =>{
                this.pdfDownloading = false;
                // window.open(url, '_blank');
                setTimeout(()=>{
                    window.location.href=url
                },10);
            });
        },
    }
}
